export type CheckoutProvider = "stripe" | "polar";

const POLAR_QUERY_VALUES = new Set(["polar", "polar.sh"]);
const STRIPE_QUERY_VALUES = new Set(["stripe"]);

export const resolveExplicitCheckoutProviderFromUrl = (
  urlLike: URL | string = window.location.href
): CheckoutProvider | null => {
  const url = typeof urlLike === "string" ? new URL(urlLike) : urlLike;
  const rawValue =
    url.searchParams.get("checkout") ??
    url.searchParams.get("checkout_provider") ??
    url.searchParams.get("payment_provider") ??
    url.searchParams.get("provider");

  const value = rawValue?.trim().toLowerCase() ?? "";
  if (POLAR_QUERY_VALUES.has(value)) {
    return "polar";
  }
  if (STRIPE_QUERY_VALUES.has(value)) {
    return "stripe";
  }

  return null;
};

export const resolveCheckoutProviderFromUrl = (
  urlLike: URL | string = window.location.href
): CheckoutProvider => resolveExplicitCheckoutProviderFromUrl(urlLike) ?? "polar";
